/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Allow_Overlap_TitleInputs */

const en_timeline_allow_overlap_title = /** @type {(inputs: Timeline_Allow_Overlap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow events to overlap; the adjacent event is automatically adjusted to keep the frame gap`)
};

const fr_timeline_allow_overlap_title = /** @type {(inputs: Timeline_Allow_Overlap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autoriser le chevauchement des événements ; l’événement adjacent est automatiquement ajusté pour maintenir l’espacement entre les cadres.`)
};

const de_timeline_allow_overlap_title = /** @type {(inputs: Timeline_Allow_Overlap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisse dürfen sich überlappen; das benachbarte Ereignis wird automatisch angepasst, um den Rahmenabstand beizubehalten.`)
};

const it_timeline_allow_overlap_title = /** @type {(inputs: Timeline_Allow_Overlap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consente la sovrapposizione degli eventi; l'evento adiacente viene regolato automaticamente per mantenere lo spazio tra i fotogrammi`)
};

const ru_timeline_allow_overlap_title = /** @type {(inputs: Timeline_Allow_Overlap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Допускается перекрытие событий; соседнее событие автоматически корректируется для сохранения промежутка между кадрами.`)
};

const es_timeline_allow_overlap_title = /** @type {(inputs: Timeline_Allow_Overlap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permitir que los eventos se superpongan; el evento adyacente se ajusta automáticamente para mantener el espacio entre fotogramas.`)
};

const zh_cn2_timeline_allow_overlap_title = /** @type {(inputs: Timeline_Allow_Overlap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`允许事件重叠；相邻事件会自动调整以保持帧间距。`)
};

const ja_timeline_allow_overlap_title = /** @type {(inputs: Timeline_Allow_Overlap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントの重複を許可します。隣接するイベントは、フレーム間の間隔を維持するように自動的に調整されます。`)
};

const hi_timeline_allow_overlap_title = /** @type {(inputs: Timeline_Allow_Overlap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घटनाओं को ओवरलैप होने दें; फ्रेम गैप बनाए रखने के लिए आसन्न घटना स्वचालित रूप से समायोजित हो जाती है।`)
};

const pt_pt2_timeline_allow_overlap_title = /** @type {(inputs: Timeline_Allow_Overlap_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permitir sobreposição de eventos; o evento adjacente é ajustado automaticamente para manter o espaçamento entre os quadros.`)
};

/**
* | output |
* | --- |
* | "Allow events to overlap; the adjacent event is automatically adjusted to keep the frame gap" |
*
* @param {Timeline_Allow_Overlap_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_allow_overlap_title = /** @type {((inputs?: Timeline_Allow_Overlap_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Allow_Overlap_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timeline_allow_overlap_title(inputs)
	if (locale === "de") return de_timeline_allow_overlap_title(inputs)
	if (locale === "it") return it_timeline_allow_overlap_title(inputs)
	if (locale === "ru") return ru_timeline_allow_overlap_title(inputs)
	if (locale === "es") return es_timeline_allow_overlap_title(inputs)
	if (locale === "zh-CN") return zh_cn2_timeline_allow_overlap_title(inputs)
	if (locale === "ja") return ja_timeline_allow_overlap_title(inputs)
	if (locale === "hi") return hi_timeline_allow_overlap_title(inputs)
	if (locale === "pt-PT") return pt_pt2_timeline_allow_overlap_title(inputs)
	return en_timeline_allow_overlap_title(inputs)
});